import { App, type URLOpenListenerEvent } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import { PushNotifications } from "@capacitor/push-notifications";
export async function currentOrigin() {
  if (!Capacitor.isNativePlatform())
    return {
      latitude: 33.8938,
      longitude: 35.5018,
      label: "Current location · Beirut",
    };
  const permission = await Geolocation.requestPermissions();
  if (permission.location !== "granted")
    throw new Error("Location permission denied");
  const p = await Geolocation.getCurrentPosition({
    enableHighAccuracy: false,
    timeout: 8000,
  });
  return {
    latitude: p.coords.latitude,
    longitude: p.coords.longitude,
    label: "Current location",
  };
}
export async function openExternal(url: string) {
  if (!/^https:\/\//.test(url) && !/^whish:/.test(url))
    throw new Error("Unsafe external URL");
  if (Capacitor.isNativePlatform())
    await Browser.open({ url, presentationStyle: "popover" });
  else window.open(url, "_blank", "noopener,noreferrer");
}
export async function registerPush(onToken: (token: string) => Promise<void>) {
  if (!Capacitor.isNativePlatform()) return;
  const result = await PushNotifications.requestPermissions();
  if (result.receive !== "granted") return;
  await PushNotifications.addListener("registration", (token) => {
    void onToken(token.value);
  });
  await PushNotifications.register();
}
export async function listenForDeepLinks(handler: (path: string) => void) {
  return App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
    const url = new URL(event.url);
    handler(`${url.pathname}${url.search}`);
  });
}
